import { useState, useCallback } from 'react';
import { useWindowResize } from 'shared/helpers/hooks/useWindowResize';

const getWidth = () =>
  window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

// https://dev.to/vitaliemaldur/resize-event-listener-using-react-hooks-1k0c
/** TODO: Add documentation */
export const useCurrentWidth = () => {
  // save current window width in the state object
  const [width, setWidth] = useState(getWidth());
  const onResize = useCallback(() => {
    setWidth(getWidth());
  }, []);
  useWindowResize(onResize);

  return width;
};
